exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".propertyPiece[data-v-6acf3ce6] {\n  border: 1px solid #ebebeb;\n  margin-top: 16px;\n  position: relative;\n}\n.propertyPiece .delPiece[data-v-6acf3ce6] {\n  position: absolute;\n  right: 0%;\n  top: 16px;\n  font-size: 20px;\n  cursor: pointer;\n}\n.just-end[data-v-6acf3ce6] {\n  justify-content: end;\n}\n.border-bottom-1[data-v-6acf3ce6] {\n  border-bottom: 1px solid #ebebeb;\n}\n", ""]);

// exports
